import React from 'react';
import { motion } from 'framer-motion';
import RibbonStreaks from './RibbonStreaks';
import FloatingBubbles from './FloatingBubbles';
const Hero = () => {
  return <section id="hero" className="relative overflow-hidden flex flex-col justify-center pt-6 pb-20 md:pt-10 md:pb-24" style={{
    backgroundColor: 'var(--cream)',
    minHeight: 'calc(100vh - 72px)'
  }} data-id="element-161">
      <RibbonStreaks data-id="element-162" />
      <FloatingBubbles data-id="element-163" />

      {/* Cream reading-area mask — protects icon/headline/subhead/CTA from
                              the ribbon. Stronger and wider than before so strands stay
                              atmospheric at the edges only. */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-[2]" style={{
      background: 'radial-gradient(ellipse 65% 55% at 50% 50%, rgba(251, 248, 244, 0.96) 0%, rgba(251, 248, 244, 0.85) 35%, rgba(251, 248, 244, 0.45) 65%, rgba(251, 248, 244, 0) 90%)'
    }} data-id="element-164" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 sm:px-8 lg:px-10 text-center -translate-y-4 md:-translate-y-6" data-id="element-165">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="mb-6" data-id="element-166">
          <span className="inline-block text-xs font-medium tracking-[0.2em] uppercase" style={{
          color: 'var(--coral)',
          // Compensate for trailing letter-spacing so the visible glyphs
          // optically center under the icon (CSS letter-spacing applies
          // after every char, including the last).
          paddingLeft: '0.2em'
        }} data-id="element-167">
            Emotionally intelligent messaging
          </span>
        </motion.div>

        {/* Main headline — three clean lines */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.1,
        ease: [0.16, 1, 0.3, 1]
      }} className="text-[40px] sm:text-5xl md:text-[60px] lg:text-[68px] font-normal leading-[1.02] tracking-[-0.01em] mb-10 md:mb-12" style={{
        color: 'var(--navy)',
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-168">
          <span className="block" data-id="element-169">For messages that</span>
          <span className="block" data-id="element-170">
            matter{' '}
            <em className="italic" style={{
            color: 'var(--coral)'
          }} data-id="element-171">
              too much
            </em>
          </span>
          <span className="block" data-id="element-172">to get wrong.</span>
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        delay: 0.25,
        ease: [0.16, 1, 0.3, 1]
      }} className="mx-auto text-[16px] md:text-[18px] lg:text-[19px] leading-[1.55]" style={{
        color: 'var(--muted)',
        maxWidth: '600px',
        letterSpacing: '0.005em'
      }} data-id="element-173">
          Rewrite what you're about to send. Understand what they really mean.
          Reply with clarity when it matters most.
        </motion.p>

        {/* CTA — simple centered stack */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: [0.16, 1, 0.3, 1]
      }} className="flex flex-col items-center justify-center" style={{
        marginTop: '24px'
      }} data-id="element-174">
          <motion.a whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} href="https://apps.apple.com/us/app/emigo-better-texting/id6748092950" target="_blank" rel="noopener noreferrer" className="inline-block" data-id="element-175">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/55BSmF1FDX8kQyzwZAZdd8/download-on-the-app-store.svg" alt="Download on the App Store" className="h-[62px] md:h-[68px]" data-id="element-176" />
          </motion.a>
          <p className="text-[13px] tracking-wide" style={{
          color: 'var(--muted-warm)',
          marginTop: '12px'
        }} data-id="element-177">
            Free. No sign-up. No personal info.
          </p>
        </motion.div>
      </div>
    </section>;
};
export default Hero;